import { dealInfoHelpers } from 'widget/player-widget';


export function isSubscriptionEnabled(dealInfo) {
  if (_.isEmpty(dealInfo)) {
    return false;
  }

  return Boolean(dealInfoHelpers.getSubscriptionPriceInfo(dealInfo));
}



// WEBPACK FOOTER //
// ./src/shared/utils/deal-info-helpers.js